// extracted by mini-css-extract-plugin
export var body = "_km-0";
export var sectionHeader = "_km-4";
export var shortcutColumns = "_km-2";
export var shortcutList = "_km-1";
export var shortcutSection = "_km-3";